<footer>
  <div class="wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <p>
            <strong>Hamiplant B.V.</strong><br />
            Venus 280<br />
            2675&nbsp;LP Honselersdijk<br />
            The Netherlands<br>
          </p>
        </div>
        <div class="col-md-4">
          <div class="nav-links">
            <a href="https://shop.hamiplant.nl/hamiplant/nl/EUR/disclaimer" title="Disclaimer">Disclaimer</a>
            <br />
            <br />
            <a href="https://shop.hamiplant.nl/hamiplant/nl/EUR/privacy-statement" title="Privacy verklaring">Privacy verklaring</a>
            <br />
            <br />
            <a href="https://shop.hamiplant.nl/hamiplant/nl/EUR/terms-and-conditions" title="Algemene voorwaarden">Algemene voorwaarden</a>
            <br />
            <br />
            <a href="https://shop.hamiplant.nl/hamiplant/nl/EUR/terms-and-conditions-of-purchase" title="Algemene inkoopvoorwaarden">Algemene inkoopvoorwaarden</a>
          </div>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
  </div>
</footer>
